import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
const classifyNumber = (x) => ({
    positive: 0 < Math.sign(x),
    zero: x === 0,
    one: x === -1 || x === 1,
});
/**
 * Renders the equation `y = ax + bx^n` using the provided coefficients (`a`, `b`, `n`) and following mathematical simplification rules
 */
export const ScoreEquation = ({ coefficients }) => {
    const { a, b, n } = coefficients;
    const aC = classifyNumber(a);
    const bC = classifyNumber(b);
    const nC = classifyNumber(n);
    const aExists = !aC.zero;
    const bExists = !bC.zero && !nC.zero;
    const nExists = !nC.zero && !(nC.positive && nC.one);
    let first = '';
    let join = '';
    let second = '';
    let power = '';
    // if the first term exists, display...
    if (aExists) {
        if (!aC.positive)
            first += '-';
        if (!aC.one)
            first += Math.abs(a);
        else
            first += 'a';
        first += 'x';
    }
    // if both terms exist, display...
    if (aExists && bExists) {
        if (bC.positive)
            join = ' + ';
        else
            join = ' - ';
    }
    if (bExists) {
        if (!aExists && !bC.positive)
            second += '-';
        if (!bC.one)
            second += Math.abs(b);
        else
            second += 'b';
        second += 'x';
        if (nExists) {
            if (!nC.positive)
                power += '-';
            else
                power += ' ';
            power += Math.abs(n);
        }
    }
    return (_jsx(Typography, { fontFamily: 'serif', fontSize: '1.25em', paddingInlineStart: 0.5, children: _jsxs("i", { children: ["y\u00A0=\u00A0", first, join, second, nExists && _jsx("sup", { children: power })] }) }));
};
